<template>
    <table class="table align-middle table-nowrap mb-0" id="customerTable">
        <thead class="table-light">
        <tr>
            <th>محصول</th>
            <th>انبار</th>
            <th>قیمت</th>
            <th>درآمد</th>
            <th scope="col">عملیات</th>
        </tr>
        </thead>
        <tbody class="list form-check-all">
        <tr class="gridjs-tr" v-for="(data, index) of resultQuery" :key="index">
            <td data-column-id="product" class="gridjs-td">
                            <span>
                              <div class="d-flex align-items-center">
                                <div class="flex-shrink-0 me-3">
                                  <div class="avatar-sm bg-light rounded p-1">
                                    <img :src="data.images[0].src" alt="" class="img-fluid d-block"/>
                                  </div>
                                </div>
                                <div class="flex-grow-1">
                                  <h5 class="fs-14 mb-1">
                                    <router-link to="#" class="text-dark">{{ data.name }}</router-link
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">
                                    دسته:
                                    <span class="fw-medium">{{ categoryStr(data.categories) }}</span>
                                  </p>
                                </div>
                              </div>
                            </span>
            </td>
            <td data-column-id="stock" class="gridjs-td">
                {{ stockStatusStr(data.stock_status) }}
            </td>
            <td data-column-id="price" class="gridjs-td" v-html="data.price_html"></td>
            <td data-column-id="income" class="gridjs-td">
                {{ data.income }}
            </td>
            <td data-column-id="action" class="gridjs-td">
        <span><div class="dropdown">
          <button
              class="btn btn-soft-secondary btn-sm dropdown"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
          >
            <i class="ri-more-fill"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <a :href="data.permalink" class="dropdown-item" target="_blank">
                                      <i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                      مشاهده محصول
                                      </a>
                                  </li>
                                  <li>
                                    <router-link v-if="false" class="dropdown-item" :to="{ name: 'product-edit', params:{ id: data.id } }">
                                      <i class="ri-pencil-fill align-bottom me-2 text-muted"></i>
                                      ویرایش
                                      </router-link>
                                      
                                  </li>
                                </ul>
                              </div>
        </span>
            </td>
        </tr>
        </tbody>


    </table>
</template>

<script>
export default {
    name: "product-list",
    props: ['resultQuery'],
    methods: {

        stockStatusStr(id) {
            if (id === 'instock') return 'موجود'
            if (id === 'outofstock') return 'ناموجود'
            if (id === 'preorder') return 'در پیش سفارش'
            return 'نا مشخص'
        },
        categoryStr(catObject) {
            return catObject[0].name
        },
    }
}
</script>

<style scoped>

</style>
